module.exports = __webpack_public_path__ + "static/media/Arrow Down.fc77c17f.svg";